<script>
const {VUE_APP_VIDEO_API_HOST} = process.env

export default {
  methods: {
    
    // async normalizeVideo(videoUrl, network) {
    //     return this.$http
    //     .get(`${VUE_APP_VIDEO_API_HOST}/video/normalize?type=${network}&url=${encodeURIComponent(videoUrl)}`, {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`}
    //       },
    //     )
    //     .then(res => res, err => err)
    // },

    async getVideoInformations(video) {
      let formData = new FormData()
      formData.append('video', video);

      this.$http.options.emulateJSON = true;

      return this.$http
        .post(`${VUE_APP_VIDEO_API_HOST}/video/infos`, formData)
        .then(res => res, err => err)
    }
  }
}
</script>